import { render } from "./SearchInput.vue?vue&type=template&id=366622da&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"

import "./SearchInput.vue?vue&type=style&index=0&id=366622da&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-366622da"

export default script